<template>
  <page>
    <template slot="title">Территория обслуживания.</template>
    <template slot="section">
      <columns>
        <column size="10">
          <heading>В настоящее время ООО «АРК-Энергосбыт» работает над проектами в 27 регионах Российской Федерации:</heading>
        </column>
      </columns>
      <columns>
        <column v-for="(regions, index) in allRegions" :key="index" size="4">
          <p v-for="region in regions" :key="region">{{ region }}</p>
        </column>
      </columns>
    </template>
    <template slot="aside">
      <aside-image :image="imageBg"/>
    </template>
  </page>
</template>

<script>
//import axios from 'axios';
import imageBg from '../../static/i/img-05.jpg';

import Columns from '@/components/columns/Columns';
import Column from '@/components/columns/Column';
import Heading from '@/components/Heading';
import Page from '@/components/Page';
import AsideImage from '@/components/AsideImage';

export default {
  components: {
    Columns,
    Column,
    Heading,
    Page,
    AsideImage,
  },
  data: () => {
    return {
      imageBg: imageBg,
      allRegions: null,
    }
  },
  mounted() {
    /*axios
      .get('../data/regions.json')
      .then(response => {
        this.allRegions = response.data;
      })*/
    this.allRegions = require('@/data/regions.json');
    this.allRegions = [
      this.allRegions.slice(0, ~~(this.allRegions.length / 2) + 1),
      this.allRegions.slice(~~(this.allRegions.length / 2) + 1)
    ];
  }
}
</script>



// WEBPACK FOOTER //
// Regions.vue?69f69a04